export default class Locale_Migrations { 
	GettingMigrationsForTeamPlanner: string = "Getting migrations for TeamPlanner";
	MigrationStarted: string = "Migration started and may take a while to complete..";
	FailedToExecuteMigration: string = "Failed to execute migration..";
	MigrationSuccessfullyExecuted: string = "Migration succesfully executed..";
	ClearAllExistingData: string = "Clear all existing data";	
}